import { useState, useEffect } from "react";
const ArrowIcon = ({ direction, index, length }) => {
  const [opacity, setOpacity] = useState(null);

  useEffect(() => {
    if (
      (index === 0 && direction === "left") ||
      (index === length - 1 && direction === "right")
    ) {
      setOpacity("opacity-20");
    }
  }, [index]);

  const leftArrowIcon = (
    <svg
      width="22"
      height="40"
      viewBox="0 0 22 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className={opacity}
        d="M20.8287 37.1088L3.51346 19.9998L20.8287 2.89083C20.9461 2.77895 21.0395 2.64481 21.1033 2.49644C21.1671 2.34807 21.2 2.18851 21.2 2.02729C21.2 1.86607 21.1671 1.7065 21.1033 1.55813C21.0395 1.40976 20.9461 1.27562 20.8287 1.16374V1.16374C20.7156 1.04859 20.5802 0.957044 20.4307 0.89453C20.2811 0.832016 20.1204 0.799805 19.958 0.799805C19.7957 0.799805 19.635 0.832016 19.4854 0.89453C19.3359 0.957044 19.2005 1.04859 19.0874 1.16374L1.34148 18.7045C0.994702 19.0484 0.799988 19.5142 0.799988 19.9998C0.799988 20.4854 0.994702 20.9512 1.34148 21.2951L19.0874 38.8359C19.2005 38.951 19.3359 39.0426 19.4854 39.1051C19.635 39.1676 19.7957 39.1998 19.958 39.1998C20.1204 39.1998 20.2811 39.1676 20.4307 39.1051C20.5802 39.0426 20.7156 38.951 20.8287 38.8359V38.8359C20.9461 38.724 21.0395 38.5899 21.1033 38.4415C21.1671 38.2931 21.2 38.1335 21.2 37.9723C21.2 37.8111 21.1671 37.6515 21.1033 37.5032C21.0395 37.3548 20.9461 37.2207 20.8287 37.1088Z"
        fill="#CCDBF0"
      />
    </svg>
  );

  const rightArrowIcon = (
    <svg
      width="22"
      height="40"
      viewBox="0 0 22 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className={opacity}
        d="M1.17138 37.1088L18.4866 19.9998L1.17138 2.89083C1.05395 2.77895 0.960536 2.64481 0.896734 2.49644C0.832933 2.34807 0.800049 2.18851 0.800049 2.02729C0.800049 1.86607 0.832933 1.7065 0.896734 1.55813C0.960536 1.40976 1.05395 1.27562 1.17138 1.16374C1.28448 1.04859 1.41981 0.957044 1.56936 0.89453C1.7189 0.832016 1.87962 0.799805 2.04199 0.799805C2.20436 0.799805 2.36508 0.832016 2.51463 0.89453C2.66418 0.957044 2.79951 1.04859 2.91261 1.16374L20.6586 18.7045C21.0053 19.0484 21.2001 19.5142 21.2001 19.9998C21.2001 20.4854 21.0053 20.9512 20.6586 21.2951L2.91261 38.8359C2.79951 38.951 2.66418 39.0426 2.51463 39.1051C2.36508 39.1676 2.20436 39.1998 2.04199 39.1998C1.87962 39.1998 1.7189 39.1676 1.56936 39.1051C1.41981 39.0426 1.28448 38.951 1.17138 38.8359C1.05395 38.724 0.960536 38.5899 0.896734 38.4415C0.832933 38.2931 0.800049 38.1335 0.800049 37.9723C0.800049 37.8111 0.832933 37.6515 0.896734 37.5032C0.960536 37.3548 1.05395 37.2207 1.17138 37.1088Z"
        fill="#CCDBF0"
      />
    </svg>
  );

  return (
    <>
      {(() => {
        if (direction === "left") {
          return leftArrowIcon;
        } else if (direction === "right") {
          return rightArrowIcon;
        }

        return null;
      })()}
    </>
  );
};

export default ArrowIcon;
